<template>
    <v-card>
        <v-toolbar color="primary">
            <v-toolbar-title class="white--text">
                Meio de recebimento para empresas
            </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <h2 class="text-xs-center mb2">Cadastre um novo meio de recebimento</h2>
            <v-select
              v-model="item_selecionado"
              item-text="descricao"
              :items="lista"
              return-object
              label="Selecione uma meio de recebimento"
            />
            <h2 v-if="item_selecionado && item_selecionado.id < 4" class="text-xs-certer mb-2">{{item_selecionado.descricao}}</h2>
            <v-layout column v-if="item_selecionado !== undefined && item_selecionado.id == 1">
            <h4 style="width: 100%; text-align: left;"> Tipo de chave pix: </h4>
            <v-radio-group
              v-model="tipo_chave_pix"
              column
            >
              <v-radio
                label="CPF"
                value="cpf"
              ></v-radio>
              <v-radio
                label="CNPJ"
                value="cnpj"
              ></v-radio>
              <v-radio
                label="Email"
                value="email"
              ></v-radio>
              <v-radio
                label="Telefone"
                value="telefone"
              ></v-radio>
              <v-radio
                label="Chave aleatória"
                value="key"
              ></v-radio>
            </v-radio-group>
              <v-text-field
                  label="Digite sua chave pix"
                  :mask="getmask(tipo_chave_pix)"
                  v-model="chave_pix"
              ></v-text-field>
            </v-layout>
            <v-layout column v-if="item_selecionado !== undefined && item_selecionado.id == 2">
              <v-flex xs12>
                <v-select
                ref="select_banco"
                v-model="selectdBanco"
                :items="bancos"
                label="Selecione o banco"
                required=false
              ></v-select>
              </v-flex>
              <v-flex xs12>
              <v-text-field
                  ref="num_agencia"
                  label="Informe a agência"
                  v-model="num_agencia"
                  required=false
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
              <v-text-field
                  ref="num_conta"
                  label="Informe o número da conta com o digito"
                  v-model="num_conta"
                  required=false
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                ref="select_conta"
                v-model="selectdConta"
                :items="tipos_conta"
                item-text="descricao"
                item-value="id"
                label="Selecione o tipo de conta"
                required=false
              ></v-select>
              </v-flex>
            </v-layout>
             <v-layout column v-if="item_selecionado !== undefined && item_selecionado.id == 3">
               <v-text-field
                  ref="cod_barras"
                  label="Didite o código de barras do boleto"
                  v-model="cod_barras"
                ></v-text-field>
             </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="fechar">
            Voltar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn :disabled="!item_selecionado" @click="cadastrarMeioRecebimento" color="primary">
            Salvar
          </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
  data () {
    return {
      item_selecionado: undefined,
      chave_pix: null,
      tipo_chave_pix: null,
      num_agencia: null,
      num_conta: null,
      selectdConta: null,
      selectdBanco: null,
      cod_barras: null,
      lista: [
        { id: 1, descricao: 'Transferência (PIX)' },
        { id: 2, descricao: 'Transferência (TED)' },
        { id: 3, descricao: 'Boleto bancário' },
        { id: 4, descricao: 'Cartão de Crédito' },
        { id: 5, descricao: 'Cartão de Débito' },
        { id: 6, descricao: 'Licitações Públicas' },
        { id: 7, descricao: 'Nota a Prazo' }
      ],
      bancos: [
        'Banco Itaú Unibanco',
        'Banco do Brasil',
        'Caixa Econômica Federal',
        'Banco Bradesco',
        'Banco Santander Brasil',
        'Banrisul',
        'Banco do Nordeste',
        'Sicoob',
        'Nubank',
        'Bancon Inter',
        'Neon',
        'Next',
        'Outro'
      ],
      tipos_conta: [
        { descricao: 'Conta Corrente', 'id': 1 },
        { descricao: 'Conta Poupança', 'id': 2 },
        { descricao: 'Conta Conjunta', 'id': 3 },
        { descricao: 'Conta Salário', 'id': 4 }
      ]
    }
  },
  methods: {
    fechar () {
      this.item_selecionado = undefined
      this.chave_pix = null
      this.num_agencia = null
      this.num_conta = null
      this.selectdConta = null
      this.selectdBanco = null
      this.cod_barras = null
      this.$emit('fechar')
    },
    cadastrarMeioRecebimento () {
      this.$store.dispatch('cadastrarMeioRecebimento', {
        tipo: this.item_selecionado.id,
        descricao: this.item_selecionado.descricao,
        chave_pix: this.chave_pix,
        cod_boleto: this.cod_barras,
        banco: this.selectdBanco,
        agencia: this.num_agencia,
        conta: this.num_conta,
        tipo_conta: this.selectdConta
      }).then(() => {
        this.$store.dispatch('pegarMeioRecebimento')
        this.fechar()
      })
    },
    getmask (tipo) {
      if (tipo === 'cpf') {
        return '###.###.###-##'
      } else if (tipo === 'cnpj') {
        return '##.###.###/####-##'
      } else if (tipo === 'telefone') {
        return '+55 (##)#####-####'
      }
    }
  },
  watch: {
    item_selecionado (val) {
      this.chave_pix = null
      this.num_agencia = null
      this.num_conta = null
      this.selectdConta = null
      this.selectdBanco = null
      this.cod_barras = null
    }
  }
}
</script>
